

export class PathException extends Error {
  constructor(
    public readonly description: string,
  ) {
    super(description);
  }

  toString(): string {
    return `PathException: ${this.description}`;
  }
}
